import type { Filters, SearchConfig } from '../../interfaces';
import Router from 'next/router';
import { filtersToResultPageBrowserQueryParams } from './resultPageQueryParams';
import { filtersToHotelPageBrowserQueryParams } from './hotelPageQueryParams';

export const updateSearchResultsPageQueryParams = async (
    mapOpen: boolean,
    filters: Filters,
    searchConfig?: SearchConfig,
): Promise<void> => {
    const queryParams = filtersToResultPageBrowserQueryParams(filters, mapOpen, true);
    await Router.replace(`/${searchConfig?.nextPath}/?${queryParams}`, `/${searchConfig?.urlPath}/?${queryParams}`, {
        shallow: true,
        scroll: false,
    });
};

export const updateHotelPageQueryParams = async (filters: Filters): Promise<void> => {
    const queryParams = filtersToHotelPageBrowserQueryParams(filters, true);
    await Router.replace(`/detaljer/[hotel]/?${queryParams}`, `/detaljer/${filters.hotel}/?${queryParams}`, {
        shallow: true,
        scroll: false,
    });
};
